import { useCabinetText, withCabinetContent } from "../../content/CabinetContentContext";
// // pages/UserSettingsPage.jsx
// import { useEffect, useState } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { auth, db } from "../../firebase";
// import { onAuthStateChanged } from "firebase/auth";
// import { doc, getDoc } from "firebase/firestore";
// import ChangeData from "./changeData"; // шлях підкоригуйте під ваш проект
// import css from "./userCabinet.module.css"; // для стилів обгортки (можна свій css)

// export default function UserSettingsPage() {
//   const { uid } = useParams();
//   const navigate = useNavigate();
//   const [me, setMe] = useState(null);
//   const [realUser, setRealUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // 1) перевіряємо, хто залогінений
//   useEffect(() => {
//     const unsub = onAuthStateChanged(auth, (u) => setMe(u));
//     return () => unsub();
//   }, []);

//   // 2) тягнемо юзера з Firestore за :uid
//   useEffect(() => {
//     (async () => {
//       try {
//         const ref = doc(db, "users", uid);
//         const snap = await getDoc(ref);
//         if (!snap.exists()) {
//           setLoading(false);
//           return;
//         }
//         setRealUser({ uid, ...snap.data() });
//         setLoading(false);
//       } catch {
//         setLoading(false);
//       }
//     })();
//   }, [uid]);

//   // 3) простий guard: не пускаємо, якщо не свій профіль (за потреби додайте роль "admin")
//   const isOwner = me && me.uid === uid;
//   if (!loading && (!me || !isOwner)) {
//     return (
//       <div className={css.changeDataWrap} style={{ padding: 24 }}>
//         <p>Доступ заборонено.</p>
//         <button className={css.likeButton} onClick={() => navigate("/")}>
//           На головну
//         </button>
//       </div>
//     );
//   }

//   if (loading || !realUser) {
//     return <div style={{ padding: 24 }}>Завантаження…</div>;
//   }

//   return (
//     <div className={css.changeDataWrap} style={{ padding: 0 }}>
//       <div className={css.changeDataWrapSmall}>
//         <div className={css.nameCountWrap}>
//           <h2 className={css.countH2}>Налаштування профілю</h2>
//           <Link to="/user" className={css.countSvg} title="Повернутись">
//             ← Назад
//           </Link>
//         </div>

//         {/* ВАЖЛИВО: режим "page" відключає позиціонування модалки,
//             і не закриває компонент автоматично після save */}
//         <ChangeData
//           mode="page"
//           scrollHeight={0}
//           realUser={realUser}
//           setCheSetinings={() => {}}
//           setRealUser={setRealUser}
//         />
//       </div>
//     </div>
//   );
// }
import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { auth, db } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import ChangeData from "./changeData";
import css from "./userCabinet.module.css";

function UserSettingsPage() {
  const t = useCabinetText("settings");
  const { uid } = useParams();
  const navigate = useNavigate();

  const [me, setMe] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const [realUser, setRealUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setMe(user || null);
      setAuthReady(true);
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    let cancelled = false;

    const loadUser = async () => {
      if (!uid) {
        setLoadingUser(false);
        return;
      }

      try {
        setLoadingUser(true);

        const userRef = doc(db, "users", uid);
        const snap = await getDoc(userRef);

        if (!cancelled) {
          if (snap.exists()) {
            setRealUser({ uid, ...snap.data() });
          } else {
            setRealUser(null);
          }
        }
      } catch (error) {
        console.error("Помилка завантаження користувача:", error);
        if (!cancelled) {
          setRealUser(null);
        }
      } finally {
        if (!cancelled) {
          setLoadingUser(false);
        }
      }
    };

    loadUser();

    return () => {
      cancelled = true;
    };
  }, [uid]);

  if (!authReady || loadingUser) {
    return <div style={{ padding: 24 }}>{t("text001")}</div>;
  }

  const isOwner = me?.uid === uid;

  if (!me || !isOwner) {
    return (
      <div className={css.changeDataWrap} style={{ padding: 24 }}>
        <p>{t("text002")}</p>
        <button className={css.likeButtonChange} onClick={() => navigate("/")}>{t("text003")}</button>
      </div>
    );
  }

  if (!realUser) {
    return (
      <div className={css.changeDataWrap} style={{ padding: 24 }}>
        <p>{t("text004")}</p>
        <button className={css.likeButtonChange} onClick={() => navigate("/")}>{t("text003")}</button>
      </div>
    );
  }

  return (
    <div className={css.changeDataWrap} style={{ padding: 0 }}>
      <div className={css.changeDataWrapSmall}>
        <div className={css.nameCountWrap}>
          <h2 className={css.countH2}>{t("text005")}</h2>
          <Link to="/user" className={css.countSvg} title={t("text006")}>{t("text007")}</Link>
        </div>

        <ChangeData
          mode="page"
          scrollHeight={0}
          realUser={realUser}
          setCheSetinings={() => navigate("/user")}
          setRealUser={setRealUser}
        />
      </div>
    </div>
  );
}

export default withCabinetContent(UserSettingsPage);
